<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [(ngModel)]="idsRegioes"
  (ngModelChange)="onSelectionChange()"
  (isFirstOpened)="firstOpened($event)"
  (search)="onSearch()">
</sgt-multi-select>
